import type { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import Join from '../pages/member/join/page';
import Login from '../pages/member/login/page';
import MyPage from '../pages/member/mypage/page';
import Passport from '../pages/passport/page';
import ClassDetail from '../pages/class-detail/page';
import TeacherDetail from '../pages/teacher-detail/page';
import PolicyPage from '../pages/policy/page';
import NotFound from '../pages/NotFound';
import ClassList from '../pages/class-list/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/member/join',
    element: (
      <PublicRoute>
        <Join />
      </PublicRoute>
    )
  },
  {
    path: '/member/login',
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    )
  },
  {
    path: '/member/mypage',
    element: (
      <PrivateRoute>
        <MyPage />
      </PrivateRoute>
    )
  },
  {
    path: '/classes',
    element: <ClassList />
  },
  {
    path: '/passport',
    element: (
      <PrivateRoute>
        <Passport />
      </PrivateRoute>
    )
  },
  {
    path: '/class/detail/:id',
    element: <ClassDetail />
  },
  {
    path: '/teacher/detail/:id',
    element: <TeacherDetail />
  },
  {
    path: '/policy/:type',
    element: <PolicyPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
